/* Add MFA Aug 19, 2023 */
/* Add scoped to Style Oct 21, 2023 */
/* Add Required indicatoor Feb 15, 2025 */
/* Fix Reset Password Bug: remove v-html Oct 25, 2025 */
/* Add fn_saveLocation Oct 31, 2026 */
<template lang="pug">
	b-container(id="kbdp-log-in" fluid class="col-12 col-md-6 pt-5")
		img(alt="KBDP logo" src="@/assets/logo-1.png" class="my-1" height="100")
		p Welcome to Kiese Business Development Platform
		div(class="forms-container text-left border mx-auto py-3 px-4 mt-4")
			span <span style="color:#ff9333;">*</span>indicates field is required.
			//- Log In
			div(v-if="d_form=='li'" )
				div(class="form-group muted")
					label(v-html="d_lbls.un")
					b-form-input(id="log-in-username" v-model="d_auth.un"  type="text"
					@focus="m_clear" @keyup.enter="m_authSignIn")
					b-form-checkbox(id="remember-un" class="my-auto" size="sm" :value="true" v-model="d_auth.run") Remember my username
				div(class="form-group muted mb-1")
					label(v-html="d_lbls.pw")
					b-form-input(id="log-in-password" v-model="d_auth.pw"  type="password" @focus="m_clear" @keyup.enter="m_authSignIn")
				div(class="small")
					span(class="pr-2") Forgot your password?
					a(href="#" @click="m_formChg($event,'fp')") Reset password
				b-button(id="btn-login" class="py-1" style="width: 80px;" :disabled="d_auth.pwVerified" variant="primary" @click="m_authSignIn")
					span(v-if="d_auth.loading" class="spinner-border spinner-border-sm " role="status")
					span( class="text-right pt-4 muted") Log In
			div(v-if="d_auth.preferredMFA=='SMS_MFA'" )
				hr
				div(class="form-group muted mb-1" )
					label MFA Authentication 
					b-form-input(id="mfa_code" v-model="d_auth.mfaCode"  placeholder="Enter MFA code" type="text")
					div
						span(v-if="!d_auth.mfaCode" style="background-color: #FFFF00;" class="blink pr-2 small" ) Check your phone for the MFA code!!
						span(v-if="d_auth.mfaCode"  style="background-color: #dddddd;" class="pr-2 small" ) Check your phone for the MFA code!!
					div
						b-button(id="btn-verify" style="width: 120px; margin-right:0.3em;"  variant="primary" :disabled="!d_auth.mfaCode" @click="m_authConfirmSignIn(d_auth.userAuthObj,d_auth.mfaCode,'SMS_MFA')") Verify Code
						b-button(id="btn-resend" style="width: 120px;"   variant="primary"  @click="m_sendResend") Resend Code
			//- Forgot PW
			div(v-else-if="d_form=='fp'" )
				div(class="py-2 font-weight-bold") Reset Your Password
				div(class="form-group muted")
					label(v-html="d_lbls.un")
					b-form-input(id="forgot-pw-username" v-model="d_auth.un"  type="text" placeholder="Enter your username" 
					@focus="m_clear" @keyup.enter="m_authForgotPassword")
				div(class="d-flex pt-3  muted")
					a(href="#" @click="m_formChg($event,'li')" class="small my-auto") {{d_lbls.btl}}
					b-button(id="btn-send-code" class="py-1 ml-auto" style="width: 100px"  variant="primary" @click="m_authForgotPassword")
						span(v-if="d_auth.loading" class="spinner-border spinner-border-sm " role="status")
						span(v-else) Send Code

			//- Reset PW
			div(v-else-if="d_form=='rp'" )
				div(class="py-2 font-weight-bold") Reset Your Password
				div(class="form-group muted")
					label Verification Code
					<span style="color:#ff9333;">*</span>
					b-form-input(id="reset-pw-verify" v-model="d_auth.vc"  type="number" placeholder="Enter verfication code")
				div(class="form-group muted mb-1")
					label(v-html="d_lbls.npw")
					b-form-input(id="reset-pw-password" v-model="d_auth.pw"  type="password"  placeholder="Enter a new password")
				div(class="small pb-2 text-grey5" )
					span {{d_lbls.pwstr}}
				div(class="d-flex pt-3 muted")
					a(href="#" @click="m_formChg($event,'li')" class="small my-auto") {{d_lbls.btl}}
					b-button(id="btn-new-pw" class="py-1 ml-auto" style="width: 150px"  variant="primary" @click="m_authForgotPasswordSubmit")
						span(v-if="d_auth.loading" class="spinner-border spinner-border-sm " role="status")
						span(v-else) {{d_lbls.cpw}}
			
			//- Change PW (Complete New Registration)
			div(v-else-if="d_form=='cp'" )
				div(class="py-2 font-weight-bold") {{d_lbls.cpw}}
				div(class="form-group muted mb-1")
					label(v-html="d_lbls.npw")
					b-form-input(id="reset-pw-password" required v-model="d_auth.pw"  type="password"  placeholder="Enter your new password")
				div(class="small pb-2 text-grey5" )
					span {{d_lbls.pwstr}}
				div(class="d-flex pt-3 muted")
					a(href="#" @click="m_formChg($event,'li')" class="small my-auto") {{d_lbls.btl}}
					b-button(id="btn-new-pw" class="py-1 ml-auto" style="width: 150px"  variant="primary" @click="m_authCompleteNewPassword")
						span(v-if="d_auth.loading" class="spinner-border spinner-border-sm " role="status")
						span(v-else)  {{d_lbls.cpw}}
			
		//- Error/Info
		div(class="error-info")
			div(v-if="d_auth.error" class="text-center text-danger")
				span {{d_auth.error}}
			div(v-else-if="d_auth.info" class="text-center text-primary")
				span {{d_auth.info}}

</template>

<script>

const wss = window.sessionStorage;
const uncookie = 'kbdp-username';
const pwStrTxt = 'Minimum 8 characters, must have at least one number, uppercase and lowercase letter.';

import {Auth} from "@aws-amplify/auth";
import {fn_appUserSession, lcl_userInfo as userInfo} from "@/utils/init.js";
import {fn_saveLocation} from "@/utils/api.js";

export default {
	name: "login",
	components: {},
	created() {
		let sessExp = wss.getItem('sessionExp') === "true";
		let logout = this.$route.params.logout;
		if (sessExp) this.d_auth.info = "Your session has expired. Please log in again to continue.";
		else if (logout) this.d_auth.info = "You have been logged out successfuly.";

		let un = this.$cookies.get(uncookie);
		if (un) {
			this.d_auth.un = un;
			this.d_auth.run = true;
		}
	},
	mounted() {
		wss.removeItem('sessionExp');
	},
	data() {
		return {
			d_form: 'li', //li, fp, rp, cp
			d_auth: {
					un: null, 
					pw: null, 
					run: null, 
					error: null, 
					info: null, 
					loading: null, 
					vc: null,
					pwVerified:false,
					mfaCode:null,
					mfaType:null,
					mfaMedium:null,
					mfaDestination:null,
					clientId:null,
					session:null,
					userPoolId:null,
					userAuthObj:null,
					mfaCodeExpiry:null,
					},
			d_lbls: fn_getLabels(),
		};
	},
	props: {
	},
	computed: {
		c_mfaCode(){return this.d_auth.mfaCode;},
		c_mfaCodeExpiry(){return (this.d_authmfaCodeExpiry<(new Date().getTime()/1000));}
	},
	methods: {
		m_formChg(e, formKey) {
			e.preventDefault();
			this.d_form = formKey;
			this.d_auth.pw = null;
			this.m_clear();
		},
		m_clear() {
			this.d_auth.error = null;
			this.d_auth.info = null;
		},


		m_authSignIn() {
			let _this = this;
			let a = this.d_auth;

			if (fn_isEmpty(a.un) || fn_isEmpty(a.pw)) {
				a.error = "Username and password can not be blank";
				return;
			}

			if (a.run) { //Remember User name
				_this.$cookies.set(uncookie, a.un, "3m"); //3 months
			}
			else {
				_this.$cookies.remove(uncookie);
			}

			a.loading = true;
			this.m_clear();
			Auth.signIn(this.d_auth.un, this.d_auth.pw).then(resp => {
				console.log('login');
				console.log(resp);
				if (resp.challengeName == "NEW_PASSWORD_REQUIRED") {
					a.pw = null;
					a.CognitoUser = resp;
					a.loading = null;
					_this.d_form = 'cp';
				}
				else{ 
				if (resp.challengeName == "SMS_MFA"){
					_this.d_auth.loading=null;
					_this.d_auth.pwVerified=true;
					_this.d_auth.userAuthObj=resp;
					_this.d_auth.clientId=resp.pool.clientId;
					_this.d_auth.userPoolId=resp.pool.userPoolId;
					_this.d_auth.session=resp.session;
					_this.d_auth.preferredMFA=resp.challengeName;
					_this.d_auth.mfaMedium=resp.challengeParam.CODE_DELIVERY_DELIVERY_MEDIUM;
					_this.d_auth.mfaDestination=resp.challengeParam.CODE_DELIVERY_DESTINATION;
					//_this.d_auth.mfaCodeExpiry=resp.signInUserSession.payload.exp;
					
				}
				else{fn_loginRoutineHelper(resp, _this);}
			}
			}).catch(err => {
				// console.log(err)
				if (err.code == "PasswordResetRequiredException") {
					a.info = err.message;
					_this.d_form = 'fp';
				}
				else {
					a.error = err.message;
				}
				a.loading = null;
				_this.$cookies.remove(uncookie);
			});
		},
		m_authForgotPassword() {
			let a = this.d_auth;
			if (fn_isEmpty(a.un)) {
				a.error = "Username can not be blank";
				return;
			}
			a.loading = true;
			this.m_clear();
			a.vc = a.pw = null;
			Auth.forgotPassword(a.un).then(resp => {
				this.d_form = 'rp';
				// resp.CodeDeliveryDetails.Destination; //Do not display. Confusing to users
				a.info = "If a valid username was entered, a verification code is sent to the email address associated with the username.";
				a.loading = null;
			}).catch(err => {
				a.error = err.message;
				a.loading = null;
			});
		},
		m_authForgotPasswordSubmit() {
			let a = this.d_auth;
			if (fn_isEmpty(a.vc) || fn_isEmpty(a.pw)) {
				a.error = "Verification code and password can not be blank";
				return;
			}
			a.loading = true;
			this.m_clear();

			Auth.forgotPasswordSubmit(a.un, a.vc, a.pw).then(resp => {
				this.d_form = 'li';
				a.vc = a.pw = null;
				a.loading = null;
				a.info = "Your password is changed successfully. You may log in to continue.";
			}).catch(err => {
				switch (err.code) {
					case "InvalidParameterException": a.error = "Passord strength requirments are not met"; break;
					default: a.error = err.message; break;
				}
				a.loading = null;
			});

		},
		m_authCompleteNewPassword() {
			let _this = this;
			let a = this.d_auth;
			if (fn_isEmpty(a.pw)) {
				a.error = "Password can not be blank";
				return;
			}
			a.loading = true;
			this.m_clear();

			Auth.completeNewPassword(a.CognitoUser, a.pw).then(resp => {
				fn_loginRoutineHelper(resp, _this);
			}).catch(err => {
				switch (err.code) {
					case "InvalidParameterException": a.error = "Password strength requirments are not met"; break;
					default: a.error = err.message; break;
				}
				a.loading = null;
			});

		},
		m_authConfirmSignIn(user,mfaCode,mfaType){
		Auth.confirmSignIn(user,mfaCode,mfaType).then(resp=>{
		fn_loginRoutineHelper(user,this);
		});


		
		},
	m_sendResend(){
	
		this.m_authSignIn();
		
	/*
		Auth.resendSignUp(this.d_auth.un).then(resp=>{
			console.log('code resent successfully');
		}).catch(err => {
				console.log('error resending code: ', err);
		});
	*/
	
	},
		m_flashMessage() {
				var checkForCodeElem=document.getElementById("checkCodeMessage");
				var blink_speed = 1000;
				var t=setInterval(function(){
				checkForCodeElem.style.visibility=(checkForCodeElem.style.visibility=='hidden'?'':'hidden');
				}, blink_speed);
			}
	},
	watch: {}
};
export {fn_chgPw, pwStrTxt};

function fn_isEmpty(val) {
	return (val || '').trim() == '';
}
function fn_getLabels() {
	return {
		un: '<span>Username<span style="color:#ff9333;">*</span></span>',
		pw: '<span>Password<span style="color:#ff9333;">*</span></span>',
		npw:'<span>New Password<span style="color:#ff9333;">*</span></span>',
		cpw: 'Change Password',
		btl: 'Back to Log In',
		// pwstr: tenantSettings.pwStrTxt
		pwstr: pwStrTxt

	};
}
function fn_loginRoutineHelper(resp, vc) {
	let pl = resp.signInUserSession.idToken.payload;
	let ui = {
		username: resp.username,
		email: pl.email,
		// sub: pl.sub,
		event_id: pl.event_id,
		auth_time: pl.auth_time * 1000,
		exp_time: pl.exp * 1000,
		keyPrefix: resp.keyPrefix,
	};
	ui.auth_time_str = new Date(ui.auth_time).toLocaleString();
	// ui.exp_time_str = new Date(ui.exp_time).toLocaleString();

	userInfo.setUserInfo(ui); //Sets token info

    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
	fn_appUserSession(ui.event_id).then((resp) => {
		if (resp.isValid) {


           console.log('After Login resp',resp);
		   console.log('timeZone',tz);
		   console.log('resp.location',resp.location);
            if(resp.location != tz){
			fn_saveLocation({username: resp.username,userSub: pl.sub, location:tz}).then(() => {})
	        .catch(err => {console.error("error:", err?.message || err);});
			}
		
		
		    
			Object.keys(resp).forEach(k => ui[k] = resp[k]);
			delete ui.isValid;
			userInfo.setUserInfo(ui);
			vc.$router.push({name: 'KBDP'});
		}
		else {
			Auth.signOut().then(() => {
				userInfo.removeUserInfo();
				vc.m_clear();
				vc.d_auth.info = "Unable to log in. User account may be disabled or invalid. Please contact application adminstrator.";
				vc.d_auth.loading = null;
			});
		}
	});
	
	
}

function fn_chgPw(cp, fn_okCB) {
	//Used in TopHdr.vue
	Auth.currentAuthenticatedUser().then(user => {
		return Auth.changePassword(user, cp.curr, cp.new1);
	}).then(resp => {
		setTimeout(() => {
			fn_okCB();
		}, 1000);
	}).catch(err => {
		// console.log('ERROR', err);
		cp.loading = null;
		switch (err.code) {
			case "InvalidParameterException": {
				if (/(previousPassword)/.test(err.message)) cp.error = "Current password is invalid";
				if (/(proposedPassword)/.test(err.message)) cp.error = "Password strength requirments are not met";
				break;
			}
			// case "NotAuthorizedException": {
			// 	cp.error = err.message;
			// 	break;
			// }
			default: {
				cp.error = err.message;
			}
		}
	});
}
</script>

<style scoped lang="less">
#kbdp-log-in {
	min-width: 300px;
	div.forms-container {
		max-width: 400px;
		box-shadow: 0em 0.05em 0.05em 0.05em #e9ecef;
		> div {
			padding: 0.5em;
			div.form-group {
				> label {
					padding-top: 0.5em;
				}
				> input {
					height: 2.25em;
					padding: 0.5em 0.5em;
				}
				#remember-un ~ label {
					font-size: 0.9em;
					padding-top: 0.2em;
				}
			}
		}
	}
	div.error-info {
		max-width: 400px;
		margin: 0.5em auto;
		font-size: 0.9em;
	}
}
.blink{
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
hr{max-width: 500px;}
</style>
